import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectFeaturesListItems, selectFeaturesQueryItems } from '../../../../../redux/features/selector';
import { features } from '../../../../../redux/features/action';
import FeatureComponent from '../components/feature.component';
import PageLoader from '../../../../../components/PageLoader';
import { selectDomainsListItems } from '../../../../../redux/domains/selector';
import { domains } from '../../../../../redux/domains/action';


const Feature= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectFeaturesQueryItems)
  const featureItems = useSelector(selectFeaturesListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const domainItems = useSelector(selectDomainsListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedFeature,
    setSelectedFeature
  ] = useState<any>( {
    Name: '',
    DomainId: 0,
    IsParent: false,
    ParentFeatureId: 0,
    FeatureTypeId: 0,
    FeatureLevelId: 0,
    LogicalGroupId: 0,
    Icon: '',
    Description: '',
    Color: '',
    Route: '',
    Code:'',
    IsActive:true,
    HasRootFolder: false,
    IsHeaderEnabled: false,
    IsValidForPortal: false,
    IsValidForPOS: false,
    IsValidForPSP: false
  })
 

  const fetchFeatureyId= ()=>{
    dispatch(features.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/features/query`,entity:'features',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedFeature({ ...selectedFeature, [field]: event });
  }

  useEffect(
    () => {
      dispatch(features.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/features/list`,entity:'features',jsonData:{
    
        }})).then(()=>{
          dispatch(domains.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/list`,
            entity: 'domains',
            jsonData: {}
        }))}).then(()=>{
      if (parmas?.id > 0) {
        fetchFeatureyId()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    })},
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedFeature(queryItems?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(features.resetAction({ actionType: 'update' }))
      await dispatch(features.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/features`,entity:'features',jsonData:{
          
    Records: [
         selectedFeature 
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(features.resetAction({ actionType: 'create' }))
      await dispatch(features.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/features`,entity:'features',jsonData:{
          
      Records: [
            selectedFeature
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/platform-management/features')
} 

const parentFeature = featureItems?.result?.items.filter(
    (subDomainData: any) => subDomainData.IsParent === true
  )
    return (
    <>
     {isLoading ? <PageLoader /> : 
          <FeatureComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedFeature={selectedFeature}
           back={back}
           handleFormSubmit={handleFormSubmit}
           parentFeature={parentFeature}
           domainDetails={domainItems?.result?.items}
          />  }
          </>
    )
    
    }
   
    export default Feature;